// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";

// function UpdateOrder({ toggleSidebar }) {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [loading, setLoading] = useState(false);

//   // State for customer data, product data, and order items
//   const [customerData, setCustomerData] = useState([]);
//   const [productData, setProductData] = useState([]);
//   const [editingItemId, setEditingItemId] = useState(null);

//   // Payment modal state
//   const [paymentModal, setPaymentModal] = useState(false);
//   const [paymentType, setPaymentType] = useState("");
//   const [paymentAmount, setPaymentAmount] = useState("");
//   const [payments, setPayments] = useState([]);

//   // Main form data
//   const [updateData, setUpdateData] = useState({
//     order_by: "",
//     order_no: "",
//     order_date: "",
//     delivery_date: "",
//     delivery_status: "",
//     customer_id: "",
//     customer_name: "",
//     mobile: "",
//     order_items: [],
//     advance_amount: "0",
//     advance_paytype: "",
//     balance: "0",
//     paid: "0",
//     total: "0",
//     created_by: "",
//     created_date: "",
//     payment_history: [],
//   });

//   // New item form data
//   const [newItem, setNewItem] = useState({
//     order_no: "",
//     product: "",
//     category: "",
//     quantity: "1",
//     weight: "",
//     rate: "",
//     making_charge: "",
//     amount: "",
//   });

//   useEffect(() => {
//     if (toggleSidebar) toggleSidebar();
//     fetchCustomerData();
//     fetchProductData();
//     if (id) {
//       fetchOrderData();
//     }
//   }, [id]);

//   const fetchOrderData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/orders.php/${id}`);
//       const orderData = response.data?.data?.[0] || response.data?.[0];

//       if (!orderData) {
//         console.error("No order data received from API");
//         throw new Error("No order data received");
//       }

//       // Process order items
//       const orderItemsWithIds = (orderData.order_items || []).map(
//         (item, index) => ({
//           ...item,
//           id: item.id || Date.now() + index,
//           product: item.product || item.product_name || "",
//         })
//       );

//       // Process payment history (excluding advance payment if included in API)
//       const paymentHistory = (orderData.payment_history || []).filter(
//         (payment) => payment.payment_type !== orderData.advance_paytype
//       );

//       // Calculate total paid amount (including advance if present)
//       const totalPaid =
//         parseFloat(orderData.advance_amount || 0) +
//         paymentHistory.reduce(
//           (sum, payment) => sum + parseFloat(payment.amount || 0),
//           0
//         );

//       // Calculate total amount from order items
//       const orderTotal = orderItemsWithIds
//         .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
//         .toFixed(2);

//       setUpdateData({
//         order_by: orderData.order_by || "",
//         order_no: orderData.order_no || "",
//         order_date: orderData.order_date || "",
//         delivery_date: orderData.delivery_date || "",
//         delivery_status: orderData.delivery_status || "",
//         customer_id: orderData.customer_id || "",
//         customer_name:
//           orderData.customer_info?.name || orderData.customer_name || "",
//         mobile: orderData.customer_info?.mobile || orderData.mobile || "",
//         order_items: orderItemsWithIds,
//         advance_amount: orderData.advance_amount || "0",
//         advance_paytype: orderData.advance_paytype || "",
//         balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
//         paid: totalPaid.toFixed(2),
//         total: orderTotal,
//         created_by: orderData.created_by || "",
//         created_date: orderData.created_date || "",
//         payment_history: paymentHistory,
//       });

//       // Set payments state
//       setPayments(paymentHistory);

//       // Set the order_no in newItem
//       setNewItem((prev) => ({
//         ...prev,
//         order_no: orderData.order_no || "",
//       }));
//     } catch (error) {
//       console.error("Error fetching order data:", error);
//       toast.error(
//         "Failed to load order data: " + error.message,
//         3000,
//         "topRight"
//       );
//     }
//   };

//   const fetchCustomerData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/customer.php`);
//       setCustomerData(response.data?.data || []);
//     } catch (error) {
//       console.log("Error fetching customer data:", error.message);
//       setCustomerData([]);
//     }
//   };

//   const fetchProductData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/product.php`);
//       setProductData(response.data?.data || []);
//     } catch (error) {
//       console.log("Error fetching product data:", error.message);
//       setProductData([]);
//     }
//   };

//   // Handle customer selection change
//   const handleCustomerChange = (e) => {
//     const selectedCustomerId = e.target.value;
//     const selectedCustomer = customerData.find(
//       (customer) => customer.customer_id === selectedCustomerId
//     );

//     if (selectedCustomer) {
//       setUpdateData({
//         ...updateData,
//         customer_id: selectedCustomer.customer_id,
//         customer_name: selectedCustomer.name || "",
//         mobile: selectedCustomer.mobile || "",
//       });
//     }
//   };

//   // Handle main form input changes
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUpdateData({
//       ...updateData,
//       [name]: value,
//     });
//   };

//   // Handle new item input changes
//   const handleItemInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewItem((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   // Handle product selection
//   const handleProductChange = (e) => {
//     const selectedProductId = e.target.value;
//     const selectedProduct = productData.find(
//       (product) => product.id === selectedProductId
//     );

//     if (selectedProduct) {
//       setNewItem((prev) => ({
//         ...prev,
//         product: selectedProduct.item_name,
//         category: selectedProduct.category,
//       }));
//     } else {
//       setNewItem((prev) => ({
//         ...prev,
//         product: "",
//         category: "",
//       }));
//     }
//   };

//   const calculateAmount = (item) => {
//     if (item.quantity && item.weight && item.rate) {
//       const baseAmount =
//         parseFloat(item.quantity) *
//         parseFloat(item.weight) *
//         parseFloat(item.rate);
//       const makingCharge = parseFloat(item.making_charge) || 0;
//       return (baseAmount + makingCharge).toFixed(2);
//     }
//     return "";
//   };

//   // Add new item to the order
//   const handleAddItem = () => {
//     if (!newItem.category) {
//       toast.error("Please select a category", 3000, "topRight");
//       return;
//     }
//     if (!newItem.product) {
//       toast.error("Please select a product", 3000, "topRight");
//       return;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       toast.error("Please enter a valid quantity", 3000, "topRight");
//       return;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       toast.error("Please enter a valid weight", 3000, "topRight");
//       return;
//     }
//     if (!newItem.rate || parseFloat(newItem.rate) <= 0) {
//       toast.error("Please enter a valid rate", 3000, "topRight");
//       return;
//     }

//     const amount = calculateAmount(newItem);
//     const itemToAdd = {
//       ...newItem,
//       id: Date.now(),
//       amount: amount,
//       order_no: updateData.order_no,
//     };

//     const updatedItems = [...updateData.order_items, itemToAdd];
//     const orderTotal = updatedItems
//       .reduce((sum, item) => sum + parseFloat(item.amount), 0)
//       .toFixed(2);

//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       payments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       order_items: updatedItems,
//       total: orderTotal,
//       balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
//       paid: totalPaid.toFixed(2),
//     });

//     setNewItem({
//       order_no: updateData.order_no,
//       product: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       rate: "",
//       making_charge: "",
//       amount: "",
//     });
//   };

//   // Edit item
//   const handleEditItem = (item) => {
//     setEditingItemId(item.id);
//     setNewItem({
//       order_no: item.order_no || updateData.order_no,
//       product: item.product,
//       category: item.category,
//       quantity: item.quantity,
//       weight: item.weight,
//       rate: item.rate,
//       making_charge: item.making_charge,
//       amount: item.amount,
//     });
//   };

//   // Update item
//   const handleUpdateItem = () => {
//     if (editingItemId === null) return;

//     const updatedItems = updateData.order_items.map((item) => {
//       if (item.id === editingItemId) {
//         const amount = calculateAmount(newItem);
//         return {
//           ...item,
//           product: newItem.product,
//           category: newItem.category,
//           quantity: newItem.quantity,
//           weight: newItem.weight,
//           rate: newItem.rate,
//           making_charge: newItem.making_charge,
//           amount: amount,
//         };
//       }
//       return item;
//     });

//     const orderTotal = updatedItems
//       .reduce((sum, item) => sum + parseFloat(item.amount), 0)
//       .toFixed(2);

//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       payments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       order_items: updatedItems,
//       total: orderTotal,
//       balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
//       paid: totalPaid.toFixed(2),
//     });

//     setEditingItemId(null);
//     setNewItem({
//       order_no: updateData.order_no,
//       product: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       rate: "",
//       making_charge: "",
//       amount: "",
//     });
//   };

//   // Remove item
//   const handleRemoveItem = (id) => {
//     const filteredItems = updateData.order_items.filter(
//       (item) => item.id !== id
//     );
//     const orderTotal = filteredItems
//       .reduce((sum, item) => sum + parseFloat(item.amount), 0)
//       .toFixed(2);

//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       payments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       order_items: filteredItems,
//       total: orderTotal,
//       balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
//       paid: totalPaid.toFixed(2),
//     });
//   };

//   // Handle advance amount or paytype change
//   const handleAdvanceChange = (e) => {
//     const advance = e.target.value || "0";
//     const totalPaid =
//       parseFloat(advance) +
//       payments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       advance_amount: advance,
//       paid: totalPaid.toFixed(2),
//       balance: (parseFloat(updateData.total || 0) - totalPaid).toFixed(2),
//     });
//   };

//   // Handle advance paytype change
//   const handleAdvancePaytypeChange = (e) => {
//     const paytype = e.target.value;
//     setUpdateData((prev) => ({
//       ...prev,
//       advance_paytype: paytype,
//     }));
//     // Recalculate totals if advance amount exists
//     if (updateData.advance_amount) {
//       handleAdvanceChange({ target: { value: updateData.advance_amount } });
//     }
//   };

//   // Payment modal functions
//   const openPayment = () => setPaymentModal(true);
//   const closePayment = () => {
//     setPaymentType("");
//     setPaymentAmount("");
//     setPaymentModal(false);
//   };

//   const handleAddPayment = () => {
//     if (!paymentType || !paymentAmount || parseFloat(paymentAmount) <= 0) {
//       toast.error(
//         "Please select payment type and enter a valid amount",
//         3000,
//         "topRight"
//       );
//       return;
//     }

//     const newPayment = {
//       order_no: updateData.order_no,
//       date: new Date().toISOString().split("T")[0],
//       payment_type: paymentType,
//       amount: parseFloat(paymentAmount).toFixed(2),
//     };

//     const updatedPayments = [...payments, newPayment];
//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       updatedPayments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       paid: totalPaid.toFixed(2),
//       balance: (parseFloat(updateData.total || 0) - totalPaid).toFixed(2),
//       payment_history: updatedPayments,
//     });

//     setPayments(updatedPayments);
//     setPaymentType("");
//     setPaymentAmount("");
//   };

//   const handleEditPayment = (index) => {
//     const paymentToEdit = payments[index];
//     setPaymentType(paymentToEdit.payment_type);
//     setPaymentAmount(paymentToEdit.amount);

//     // Remove the payment being edited
//     const updatedPayments = payments.filter((_, i) => i !== index);
//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       updatedPayments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setPayments(updatedPayments);
//     setUpdateData({
//       ...updateData,
//       paid: totalPaid.toFixed(2),
//       balance: (parseFloat(updateData.total || 0) - totalPaid).toFixed(2),
//       payment_history: updatedPayments,
//     });
//   };

//   const handleDeletePayment = (index) => {
//     const updatedPayments = payments.filter((_, i) => i !== index);
//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       updatedPayments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setPayments(updatedPayments);
//     setUpdateData({
//       ...updateData,
//       paid: totalPaid.toFixed(2),
//       balance: (parseFloat(updateData.total || 0) - totalPaid).toFixed(2),
//       payment_history: updatedPayments,
//     });
//   };

//   const [showModal, setShowModal] = useState(false);

//   // Validate form before submission or printing
//   const validateForm = () => {
//     if (!updateData.order_by) {
//       toast.error("Please select order by", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.customer_id) {
//       toast.error("Please select a customer", 3000, "topRight");
//       return false;
//     }
//     if (updateData.order_items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.order_date) {
//       toast.error("Please select an order date", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   // Prepare payload for API
//   const preparePayload = () => {
//     const orderItems = updateData.order_items.map(({ id, ...item }) => item);
//     const paymentHistory = [...payments];
//     if (updateData.advance_amount && updateData.advance_paytype) {
//       paymentHistory.unshift({
//         order_no: updateData.order_no,
//         date: updateData.order_date,
//         payment_type: updateData.advance_paytype,
//         amount: parseFloat(updateData.advance_amount).toFixed(2),
//       });
//     }
//     return {
//       ...updateData,
//       order_items: orderItems,
//       payment_history: paymentHistory,
//     };
//   };

//   // Save order to API
//   const saveOrder = async () => {
//     const payload = preparePayload();
//     const response = await axios.put(`${ApiUrl}/Api/orders.php/${id}`, payload);
//     if (response.status !== 200) {
//       throw new Error(response.data.message || "Failed to update order data");
//     }
//     return response;
//   };

//   // Submit updated order
//   const handleSubmit = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       await saveOrder();
//       toast.success("Order updated successfully!", 3000, "topRight");
//       navigate("/orders");
//     } catch (error) {
//       console.error("Error updating order:", error);
//       toast.error(
//         `Failed to update order: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle print action
//   const handlePrint = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       await saveOrder();
//       toast.success("Order saved successfully!", 3000, "topRight");
//       setShowModal(true);
//     } catch (error) {
//       console.error("Error saving order for print:", error);
//       toast.error(
//         `Failed to save order: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Confirm print action
//   const handleConfirmPrint = () => {
//     setShowModal(false);
//     navigate(`/order-big-bill/${updateData.order_no}`);
//   };

//   // Cancel print action
//   const handleCancelPrint = () => {
//     setShowModal(false);
//     navigate("/orders");
//   };

//   // Filter products based on selected category
//   const filteredProducts = productData.filter(
//     (product) => product.category === newItem.category
//   );

//   return (
//     <>
//       <div className="container-fluid">
//         <div className="row g-3">
//           {/* Left Column - 4 units */}
//           <div className="col-lg-3">
//             <div className="card p-2 h-100">
//               <div className="row g-2">
//                 <div className="col-md-6">
//                   <label className="form-label">Order No</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Order No"
//                     value={updateData.order_no}
//                     disabled
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Order Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     name="order_date"
//                     value={updateData.order_date}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* Right Column - 8 units */}
//           <div className="col-lg-9">
//             <div className="card h-100 p-2">
//               <div className="row g-2">
//                 <div className="col-sm-6 col-md-2">
//                   <label className="form-label">Order By</label>
//                   <select
//                     className="form-control"
//                     name="order_by"
//                     value={updateData.order_by}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select Order By</option>
//                     <option value="By Shop">By Shop</option>
//                     <option value="By Customer">By Customer</option>
//                   </select>
//                 </div>

//                 <div className="col-sm-6 col-md-4">
//                   <label className="form-label">Customer Name</label>
//                   <div className="input-group">
//                     <select
//                       className="form-select"
//                       onChange={handleCustomerChange}
//                       value={updateData.customer_id}
//                     >
//                       <option value="">Select Customer</option>
//                       {Array.isArray(customerData) &&
//                         customerData.map((item) => (
//                           <option
//                             key={item.customer_id}
//                             value={item.customer_id}
//                           >
//                             {item.customer_id} - {item.name}
//                           </option>
//                         ))}
//                     </select>

//                     <div className="btn-group">
//                       <button
//                         type="button"
//                         className="btn btn-outline-dark btn-sm"
//                       >
//                         <i className="bi bi-plus"></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-sm-6 col-md-2">
//                   <label className="form-label">Mobile Number</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mobile"
//                     placeholder="Mobile Number"
//                     value={updateData.mobile}
//                     onChange={handleInputChange}
//                     disabled
//                   />
//                 </div>

//                 <div className="col-sm-6 col-md-2">
//                   <label className="form-label">Delivery Status</label>
//                   <select
//                     className="form-select"
//                     name="delivery_status"
//                     value={updateData.delivery_status}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select Delivery</option>
//                     <option value="Inprogress">Inprogress</option>
//                     <option value="Confirm">Confirm</option>
//                   </select>
//                 </div>

//                 {updateData.delivery_status === "Confirm" && (
//                   <div className="col-sm-6 col-md-2">
//                     <label className="form-label">Delivery Date</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       name="delivery_date"
//                       value={updateData.delivery_date}
//                       onChange={handleInputChange}
//                       min={updateData.order_date}
//                     />
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Order Items Section */}
//         <div className="card card-body mt-2">
//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Select Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 name="category"
//                 onChange={handleItemInputChange}
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Product Name</label>
//               <select
//                 className="form-select"
//                 value={newItem.product}
//                 onChange={handleProductChange}
//               >
//                 <option value="">Select Product</option>
//                 {filteredProducts.map((product) => (
//                   <option key={product.id} value={product.id}>
//                     {product.item_name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 className="form-control"
//                 placeholder="Qty"
//                 name="quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//                 min="1"
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Weight (g)"
//                 name="weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//                 step="0.001"
//                 min="0"
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Rate</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Rate"
//                 name="rate"
//                 value={newItem.rate}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">MC</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="MC"
//                 name="making_charge"
//                 value={newItem.making_charge}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>
//             <div className="col-md-1">
//               <label className="form-label">Amount</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Amount"
//                 value={calculateAmount(newItem)}
//                 readOnly
//                 disabled
//               />
//             </div>

//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm w-100 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm w-100"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         {/* Item List and Summary Section */}
//         <div className="container-fluid mt-2">
//           <div className="row">
//             <div className="col-lg-8">
//               <div className="row">
//                 <div className="card card-body">
//                   <h6>Item List</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Category</th>
//                             <th>Product</th>
//                             <th>Qty</th>
//                             <th>Weight</th>
//                             <th>Rate</th>
//                             <th>Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.order_items.map((item, index) => (
//                             <tr key={item.id}>
//                               <td>{index + 1}</td>
//                               <td>{item.category}</td>
//                               <td>{item.product}</td>
//                               <td>{item.quantity}</td>
//                               <td>{item.weight}</td>
//                               <td>{item.rate}</td>
//                               <td>₹{item.amount}</td>
//                               <td>
//                                 <button
//                                   className="btn btn-sm btn-warning me-1"
//                                   onClick={() => handleEditItem(item)}
//                                 >
//                                   <i className="bi bi-pencil"></i>
//                                 </button>
//                                 <button
//                                   className="btn btn-sm btn-danger"
//                                   onClick={() => handleRemoveItem(item.id)}
//                                 >
//                                   <i className="bi bi-trash"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}
//                           {updateData.order_items.length === 0 && (
//                             <tr>
//                               <td colSpan="8" className="text-center">
//                                 No items added
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>

//                       <div className="row">
//                         <div className="col-lg-8"></div>
//                         <div className="col-lg-4">
//                           <div className="d-flex">
//                             <h6 className="mt-2">Total: </h6>
//                             <input
//                               className="form-control mx-2"
//                               placeholder="₹"
//                               readOnly
//                               value={updateData.total || "0.00"}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Form Card - Right side */}
//             <div className="col-lg-4 mb-5">
//               <div className="card p-3">
//                 <div className="row">
//                   <div className="col-md-2">
//                     <label className="form-label">Advance</label>
//                   </div>
//                   <div className="col-md-5">
//                     <select
//                       className="form-select"
//                       value={updateData.advance_paytype}
//                       onChange={handleAdvancePaytypeChange}
//                     >
//                       <option value="">Select Paytype</option>
//                       <option value="Cash">Cash</option>
//                       <option value="Gpay">Gpay</option>
//                       <option value="Phonepe">Phonepe</option>
//                       <option value="Paytm">Paytm</option>
//                       <option value="Credit">Credit</option>
//                       <option value="Debit">Debit</option>
//                     </select>
//                   </div>
//                   <div className="col-md-5">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       name="advance_amount"
//                       value={updateData.advance_amount}
//                       onChange={(e) =>
//                         handleAdvanceChange({
//                           target: {
//                             name: e.target.name,
//                             value: e.target.value.replace(/\D/g, ""), // only digits
//                           },
//                         })
//                       }
//                       min="0"
//                     />
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Total</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.total || ""}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-2 d-flex justify-content-center">
//                   <button
//                     className="btn btn-success btn-sm w-50"
//                     onClick={openPayment}
//                   >
//                     Update Payment +
//                   </button>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Paid</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="paid"
//                       value={updateData.paid || ""}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Balance</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.balance || ""}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-secondary w-100"
//                       onClick={() => navigate("/orders")}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-primary w-100"
//                       onClick={handlePrint}
//                       disabled={loading}
//                     >
//                       Print
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-success w-100"
//                       onClick={handleSubmit}
//                       disabled={loading}
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Add Payment Modal */}
//       <div
//         className={`modal fade ${paymentModal ? "show" : ""}`}
//         style={{ display: paymentModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="addCustomerModalLabel"
//         aria-hidden={!paymentModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="addCustomerModalLabel"
//               >
//                 Update Payment
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closePayment}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="row">
//                 <div className="col-lg-4">
//                   <p>
//                     Advance:{" "}
//                     <span className="text-primary">
//                       {parseFloat(updateData.advance_amount || 0).toFixed(2)}
//                     </span>
//                   </p>
//                 </div>
//                 <div className="col-lg-4">
//                   <p>
//                     Balance:{" "}
//                     <span className="text-success">
//                       {parseFloat(updateData.balance || 0).toFixed(2)}
//                     </span>
//                   </p>
//                 </div>
//                 <div className="col-lg-4">
//                   <p>
//                     Paid:{" "}
//                     <span className="text-primary">
//                       {parseFloat(updateData.paid || 0).toFixed(2)}
//                     </span>
//                   </p>
//                 </div>
//               </div>

//               <div className="row">
//                 <div className="col-lg-6">
//                   <select
//                     className="form-select"
//                     value={paymentType}
//                     onChange={(e) => setPaymentType(e.target.value)}
//                   >
//                     <option value="">Select Paytype</option>
//                     <option value="Cash">Cash</option>
//                     <option value="Gpay">Gpay</option>
//                     <option value="Phonepe">Phonepe</option>
//                     <option value="Paytm">Paytm</option>
//                     <option value="Credit">Credit</option>
//                     <option value="Debit">Debit</option>
//                   </select>
//                 </div>
//                 <div className="col-lg-4">
//                   <input
//                     type="tel"
//                     className="form-control"
//                     value={paymentAmount}
//                     onChange={(e) => setPaymentAmount(e.target.value)}
//                     placeholder="Enter Amount"
//                     min="0"
//                     step="0.01"
//                   />
//                 </div>
//                 <div className="col-lg-2">
//                   <button
//                     className="btn btn-primary btn-sm"
//                     onClick={handleAddPayment}
//                   >
//                     Add +
//                   </button>
//                 </div>
//               </div>

//               <div
//                 className="card mt-3"
//                 style={{
//                   borderRadius: "5px",
//                   backgroundColor: "#E8F0FA",
//                 }}
//               >
//                 <div className="card-body">
//                   <div className="table-responsive">
//                     <table className="table table-border">
//                       <thead>
//                         <tr>
//                           <th>S.No</th>
//                           <th>Pay Type</th>
//                           <th>Paid Amount</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {payments.length > 0 ? (
//                           payments.map((payment, index) => (
//                             <tr key={index}>
//                               <td>{index + 1}</td>
//                               <td>{payment.payment_type}</td>
//                               <td>₹{parseFloat(payment.amount).toFixed(2)}</td>
//                               <td>
//                                 <button
//                                   className="btn btn-light btn-sm me-2"
//                                   onClick={() => handleEditPayment(index)}
//                                 >
//                                   <i className="fa fa-edit text-info"></i>
//                                 </button>
//                                 <button
//                                   className="btn btn-light btn-sm me-2"
//                                   onClick={() => handleDeletePayment(index)}
//                                 >
//                                   <i className="fa fa-trash text-danger"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan="4" className="text-center">
//                               No payments added
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>

//               <div className="text-end mt-2">
//                 <button
//                   className="btn btn-success btn-sm"
//                   onClick={closePayment}
//                 >
//                   Update
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="printModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6 className="modal-title text-primary" id="printModalLabel">
//                 Print Confirmation
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={handleCancelPrint}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="text-center">
//                 <p>Do you want to print the order bill?</p>
//               </div>
//               <div className="d-flex justify-content-center mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm mx-2"
//                   onClick={handleCancelPrint}
//                   disabled={loading}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-sm"
//                   onClick={handleConfirmPrint}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "Yes"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {(paymentModal || showModal) && (
//         <div className="modal-backdrop fade show"></div>
//       )}
//     </>
//   );
// }

// export default UpdateOrder;




// import axios from "axios";
// import { useEffect, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";
// import ApiUrl from "../Environment/ApiUrl";
// import { useToast } from "../Toast/ToastContext";

// function UpdateOrder({ toggleSidebar }) {
//   const { id } = useParams();
//   const navigate = useNavigate();
//   const toast = useToast();
//   const [loading, setLoading] = useState(false);
//   const [customerData, setCustomerData] = useState([]);
//   const [productData, setProductData] = useState([]);
//   const [editingItemId, setEditingItemId] = useState(null);
//   const [paymentModal, setPaymentModal] = useState(false);
//   const [paymentType, setPaymentType] = useState("");
//   const [paymentAmount, setPaymentAmount] = useState("");
//   const [payments, setPayments] = useState([]);
//   const [showModal, setShowModal] = useState(false);

//   const [updateData, setUpdateData] = useState({
//     order_by: "",
//     order_no: "",
//     order_date: "",
//     delivery_date: "",
//     delivery_status: "",
//     customer_id: "",
//     customer_name: "",
//     mobile: "",
//     order_items: [],
//     advance_amount: "0",
//     advance_paytype: "",
//     balance: "0",
//     paid: "0",
//     total: "0",
//     created_by: "",
//     created_date: "",
//     payment_history: [],
//   });

//   const [newItem, setNewItem] = useState({
//     order_no: "",
//     product: "",
//     category: "",
//     quantity: "1",
//     weight: "",
//     rate: "",
//     making_charge: "",
//     making_wastage: "",
//     amount: "",
//   });

//   useEffect(() => {
//     if (toggleSidebar) toggleSidebar();
//     fetchCustomerData();
//     fetchProductData();
//     if (id) {
//       fetchOrderData();
//     }
//   }, [id]);

//   const fetchOrderData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/orders.php/${id}`);
//       const orderData = response.data?.data?.[0] || response.data?.[0];

//       if (!orderData) {
//         console.error("No order data received from API");
//         throw new Error("No order data received");
//       }

//       const orderItemsWithIds = (orderData.order_items || []).map(
//         (item, index) => ({
//           ...item,
//           id: item.id || Date.now() + index,
//           product: item.product || item.product_name || "",
//           making_wastage: item.making_wastage || "",
//         })
//       );

//       const paymentHistory = (orderData.payment_history || []).filter(
//         (payment) => payment.payment_type !== orderData.advance_paytype
//       );

//       const totalPaid =
//         parseFloat(orderData.advance_amount || 0) +
//         paymentHistory.reduce(
//           (sum, payment) => sum + parseFloat(payment.amount || 0),
//           0
//         );

//       const orderTotal = orderItemsWithIds
//         .reduce((sum, item) => sum + parseFloat(item.amount || 0), 0)
//         .toFixed(2);

//       setUpdateData({
//         order_by: orderData.order_by || "",
//         order_no: orderData.order_no || "",
//         order_date: orderData.order_date || "",
//         delivery_date: orderData.delivery_date || "",
//         delivery_status: orderData.delivery_status || "",
//         customer_id: orderData.customer_id || "",
//         customer_name:
//           orderData.customer_info?.name || orderData.customer_name || "",
//         mobile: orderData.customer_info?.mobile || orderData.mobile || "",
//         order_items: orderItemsWithIds,
//         advance_amount: orderData.advance_amount || "0",
//         advance_paytype: orderData.advance_paytype || "",
//         balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
//         paid: totalPaid.toFixed(2),
//         total: orderTotal,
//         created_by: orderData.created_by || "",
//         created_date: orderData.created_date || "",
//         payment_history: paymentHistory,
//       });

//       setPayments(paymentHistory);

//       setNewItem((prev) => ({
//         ...prev,
//         order_no: orderData.order_no || "",
//       }));
//     } catch (error) {
//       console.error("Error fetching order data:", error);
//       toast.error(
//         "Failed to load order data: " + error.message,
//         3000,
//         "topRight"
//       );
//     }
//   };

//   const fetchCustomerData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/customer.php`);
//       setCustomerData(response.data?.data || []);
//     } catch (error) {
//       console.log("Error fetching customer data:", error.message);
//       setCustomerData([]);
//     }
//   };

//   const fetchProductData = async () => {
//     try {
//       const response = await axios.get(`${ApiUrl}/Api/product.php`);
//       setProductData(response.data?.data || []);
//     } catch (error) {
//       console.log("Error fetching product data:", error.message);
//       setProductData([]);
//     }
//   };

//   const handleCustomerChange = (e) => {
//     const selectedCustomerId = e.target.value;
//     const selectedCustomer = customerData.find(
//       (customer) => customer.customer_id === selectedCustomerId
//     );

//     if (selectedCustomer) {
//       setUpdateData({
//         ...updateData,
//         customer_id: selectedCustomer.customer_id,
//         customer_name: selectedCustomer.name || "",
//         mobile: selectedCustomer.mobile || "",
//       });
//     }
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setUpdateData({
//       ...updateData,
//       [name]: value,
//     });
//   };

//   const handleItemInputChange = (e) => {
//     const { name, value } = e.target;
//     setNewItem((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleProductChange = (e) => {
//     const selectedProductId = e.target.value;
//     const selectedProduct = productData.find(
//       (product) => product.id === selectedProductId
//     );

//     if (selectedProduct) {
//       setNewItem((prev) => ({
//         ...prev,
//         product: selectedProduct.item_name,
//         category: selectedProduct.category,
//       }));
//     } else {
//       setNewItem((prev) => ({
//         ...prev,
//         product: "",
//         category: "",
//       }));
//     }
//   };

//   const calculateAmount = (item) => {
//     if (item.quantity && item.weight && item.rate) {
//       const baseAmount =
//         parseFloat(item.quantity) *
//         parseFloat(item.weight) *
//         parseFloat(item.rate);
//       const makingCharge = parseFloat(item.making_charge) || 0;
//       const makingWastage = parseFloat(item.making_wastage) || 0;
//       return (baseAmount + makingCharge + makingWastage).toFixed(2);
//     }
//     return "";
//   };

//   const handleAddItem = () => {
//     if (!newItem.category) {
//       toast.error("Please select a category", 3000, "topRight");
//       return;
//     }
//     if (!newItem.product) {
//       toast.error("Please select a product", 3000, "topRight");
//       return;
//     }
//     if (!newItem.quantity || parseFloat(newItem.quantity) <= 0) {
//       toast.error("Please enter a valid quantity", 3000, "topRight");
//       return;
//     }
//     if (!newItem.weight || parseFloat(newItem.weight) <= 0) {
//       toast.error("Please enter a valid weight", 3000, "topRight");
//       return;
//     }
//     if (!newItem.rate || parseFloat(newItem.rate) <= 0) {
//       toast.error("Please enter a valid rate", 3000, "topRight");
//       return;
//     }

//     const amount = calculateAmount(newItem);
//     const itemToAdd = {
//       ...newItem,
//       id: Date.now(),
//       amount: amount,
//       order_no: updateData.order_no,
//     };

//     const updatedItems = [...updateData.order_items, itemToAdd];
//     const orderTotal = updatedItems
//       .reduce((sum, item) => sum + parseFloat(item.amount), 0)
//       .toFixed(2);

//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       payments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       order_items: updatedItems,
//       total: orderTotal,
//       balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
//       paid: totalPaid.toFixed(2),
//     });

//     setNewItem({
//       order_no: updateData.order_no,
//       product: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       rate: "",
//       making_charge: "",
//       making_wastage: "",
//       amount: "",
//     });
//   };

//   const handleEditItem = (item) => {
//     setEditingItemId(item.id);
//     setNewItem({
//       order_no: item.order_no || updateData.order_no,
//       product: item.product,
//       category: item.category,
//       quantity: item.quantity,
//       weight: item.weight,
//       rate: item.rate,
//       making_charge: item.making_charge,
//       making_wastage: item.making_wastage,
//       amount: item.amount,
//     });
//   };

//   const handleUpdateItem = () => {
//     if (editingItemId === null) return;

//     const updatedItems = updateData.order_items.map((item) => {
//       if (item.id === editingItemId) {
//         const amount = calculateAmount(newItem);
//         return {
//           ...item,
//           product: newItem.product,
//           category: newItem.category,
//           quantity: newItem.quantity,
//           weight: newItem.weight,
//           rate: newItem.rate,
//           making_charge: newItem.making_charge,
//           making_wastage: newItem.making_wastage,
//           amount: amount,
//         };
//       }
//       return item;
//     });

//     const orderTotal = updatedItems
//       .reduce((sum, item) => sum + parseFloat(item.amount), 0)
//       .toFixed(2);

//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       payments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       order_items: updatedItems,
//       total: orderTotal,
//       balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
//       paid: totalPaid.toFixed(2),
//     });

//     setEditingItemId(null);
//     setNewItem({
//       order_no: updateData.order_no,
//       product: "",
//       category: "",
//       quantity: "1",
//       weight: "",
//       rate: "",
//       making_charge: "",
//       making_wastage: "",
//       amount: "",
//     });
//   };

//   const handleRemoveItem = (id) => {
//     const filteredItems = updateData.order_items.filter(
//       (item) => item.id !== id
//     );
//     const orderTotal = filteredItems
//       .reduce((sum, item) => sum + parseFloat(item.amount), 0)
//       .toFixed(2);

//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       payments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       order_items: filteredItems,
//       total: orderTotal,
//       balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
//       paid: totalPaid.toFixed(2),
//     });
//   };

//   const handleAdvanceChange = (e) => {
//     const advance = e.target.value || "0";
//     const totalPaid =
//       parseFloat(advance) +
//       payments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       advance_amount: advance,
//       paid: totalPaid.toFixed(2),
//       balance: (parseFloat(updateData.total || 0) - totalPaid).toFixed(2),
//     });
//   };

//   const handleAdvancePaytypeChange = (e) => {
//     const paytype = e.target.value;
//     setUpdateData((prev) => ({
//       ...prev,
//       advance_paytype: paytype,
//     }));
//     if (updateData.advance_amount) {
//       handleAdvanceChange({ target: { value: updateData.advance_amount } });
//     }
//   };

//   const openPayment = () => setPaymentModal(true);
//   const closePayment = () => {
//     setPaymentType("");
//     setPaymentAmount("");
//     setPaymentModal(false);
//   };

//   const handleAddPayment = () => {
//     if (!paymentType || !paymentAmount || parseFloat(paymentAmount) <= 0) {
//       toast.error(
//         "Please select payment type and enter a valid amount",
//         3000,
//         "topRight"
//       );
//       return;
//     }

//     const newPayment = {
//       order_no: updateData.order_no,
//       date: new Date().toISOString().split("T")[0],
//       payment_type: paymentType,
//       amount: parseFloat(paymentAmount).toFixed(2),
//     };

//     const updatedPayments = [...payments, newPayment];
//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       updatedPayments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setUpdateData({
//       ...updateData,
//       paid: totalPaid.toFixed(2),
//       balance: (parseFloat(updateData.total || 0) - totalPaid).toFixed(2),
//       payment_history: updatedPayments,
//     });

//     setPayments(updatedPayments);
//     setPaymentType("");
//     setPaymentAmount("");
//   };

//   const handleEditPayment = (index) => {
//     const paymentToEdit = payments[index];
//     setPaymentType(paymentToEdit.payment_type);
//     setPaymentAmount(paymentToEdit.amount);

//     const updatedPayments = payments.filter((_, i) => i !== index);
//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       updatedPayments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setPayments(updatedPayments);
//     setUpdateData({
//       ...updateData,
//       paid: totalPaid.toFixed(2),
//       balance: (parseFloat(updateData.total || 0) - totalPaid).toFixed(2),
//       payment_history: updatedPayments,
//     });
//   };

//   const handleDeletePayment = (index) => {
//     const updatedPayments = payments.filter((_, i) => i !== index);
//     const totalPaid =
//       parseFloat(updateData.advance_amount || 0) +
//       updatedPayments.reduce(
//         (sum, payment) => sum + parseFloat(payment.amount || 0),
//         0
//       );

//     setPayments(updatedPayments);
//     setUpdateData({
//       ...updateData,
//       paid: totalPaid.toFixed(2),
//       balance: (parseFloat(updateData.total || 0) - totalPaid).toFixed(2),
//       payment_history: updatedPayments,
//     });
//   };

//   const validateForm = () => {
//     if (!updateData.order_by) {
//       toast.error("Please select order by", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.customer_id) {
//       toast.error("Please select a customer", 3000, "topRight");
//       return false;
//     }
//     if (updateData.order_items.length === 0) {
//       toast.error("Please add at least one item", 3000, "topRight");
//       return false;
//     }
//     if (!updateData.order_date) {
//       toast.error("Please select an order date", 3000, "topRight");
//       return false;
//     }
//     return true;
//   };

//   const preparePayload = () => {
//     const orderItems = updateData.order_items.map(({ id, ...item }) => item);
//     const paymentHistory = [...payments];
//     if (updateData.advance_amount && updateData.advance_paytype) {
//       paymentHistory.unshift({
//         order_no: updateData.order_no,
//         date: updateData.order_date,
//         payment_type: updateData.advance_paytype,
//         amount: parseFloat(updateData.advance_amount).toFixed(2),
//       });
//     }
//     return {
//       ...updateData,
//       order_items: orderItems,
//       payment_history: paymentHistory,
//     };
//   };

//   const saveOrder = async () => {
//     const payload = preparePayload();
//     const response = await axios.put(`${ApiUrl}/Api/orders.php/${id}`, payload);
//     if (response.status !== 200) {
//       throw new Error(response.data.message || "Failed to update order data");
//     }
//     return response;
//   };

//   const handleSubmit = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       await saveOrder();
//       toast.success("Order updated successfully!", 3000, "topRight");
//       navigate("/orders");
//     } catch (error) {
//       console.error("Error updating order:", error);
//       toast.error(
//         `Failed to update order: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handlePrint = async () => {
//     if (!validateForm()) return;

//     setLoading(true);
//     try {
//       await saveOrder();
//       toast.success("Order saved successfully!", 3000, "topRight");
//       setShowModal(true);
//     } catch (error) {
//       console.error("Error saving order for print:", error);
//       toast.error(
//         `Failed to save order: ${
//           error.response?.data?.message || error.message
//         }`,
//         3000,
//         "topRight"
//       );
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleConfirmPrint = () => {
//     setShowModal(false);
//     navigate(`/order-big-bill/${updateData.order_no}`);
//   };

//   const handleCancelPrint = () => {
//     setShowModal(false);
//     navigate("/orders");
//   };

//   const filteredProducts = productData.filter(
//     (product) => product.category === newItem.category
//   );

//   return (
//     <>
//       <div className="container-fluid">
//         <div className="row g-3">
//           <div className="col-lg-3">
//             <div className="card p-2 h-100">
//               <div className="row g-2">
//                 <div className="col-md-6">
//                   <label className="form-label">Order ID</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     placeholder="Order No"
//                     value={updateData.order_no}
//                     disabled
//                     readOnly
//                   />
//                 </div>
//                 <div className="col-md-6">
//                   <label className="form-label">Order Date</label>
//                   <input
//                     type="date"
//                     className="form-control"
//                     name="order_date"
//                     value={updateData.order_date}
//                     onChange={handleInputChange}
//                   />
//                 </div>
//               </div>
//             </div>
//           </div>

//           <div className="col-lg-9">
//             <div className="card h-100 p-2">
//               <div className="row g-2">
//                 <div className="col-sm-6 col-md-2">
//                   <label className="form-label">Order By</label>
//                   <select
//                     className="form-control"
//                     name="order_by"
//                     value={updateData.order_by}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select Order By</option>
//                     <option value="By Shop">By Shop</option>
//                     <option value="By Customer">By Customer</option>
//                   </select>
//                 </div>

//                 <div className="col-sm-6 col-md-4">
//                   <label className="form-label">Customer Name</label>
//                   <div className="input-group">
//                     <select
//                       className="form-select"
//                       onChange={handleCustomerChange}
//                       value={updateData.customer_id}
//                     >
//                       <option value="">Select Customer</option>
//                       {Array.isArray(customerData) &&
//                         customerData.map((item) => (
//                           <option
//                             key={item.customer_id}
//                             value={item.customer_id}
//                           >
//                             {item.customer_id} - {item.name}
//                           </option>
//                         ))}
//                     </select>
//                     <div className="btn-group">
//                       <button
//                         type="button"
//                         className="btn btn-outline-dark btn-sm"
//                       >
//                         <i className="bi bi-plus"></i>
//                       </button>
//                     </div>
//                   </div>
//                 </div>

//                 <div className="col-sm-6 col-md-2">
//                   <label className="form-label">Mobile Number</label>
//                   <input
//                     type="text"
//                     className="form-control"
//                     name="mobile"
//                     placeholder="Mobile Number"
//                     value={updateData.mobile}
//                     onChange={handleInputChange}
//                     disabled
//                   />
//                 </div>

//                 <div className="col-sm-6 col-md-2">
//                   <label className="form-label">Delivery Status</label>
//                   <select
//                     className="form-select"
//                     name="delivery_status"
//                     value={updateData.delivery_status}
//                     onChange={handleInputChange}
//                   >
//                     <option value="">Select Delivery</option>
//                     <option value="Inprogress">Inprogress</option>
//                     <option value="Confirm">Confirm</option>
//                   </select>
//                 </div>

//                 {updateData.delivery_status === "Confirm" && (
//                   <div className="col-sm-6 col-md-2">
//                     <label className="form-label">Delivery Date</label>
//                     <input
//                       type="date"
//                       className="form-control"
//                       name="delivery_date"
//                       value={updateData.delivery_date}
//                       onChange={handleInputChange}
//                       min={updateData.order_date}
//                     />
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         <div className="card card-body mt-2">
//           <div className="row">
//             <div className="col-md-2">
//               <label className="form-label">Select Category</label>
//               <select
//                 className="form-select"
//                 value={newItem.category}
//                 name="category"
//                 onChange={(e) => {
//                   handleItemInputChange(e);
//                   setNewItem((prev) => ({ ...prev, product: "" }));
//                 }}
//               >
//                 <option value="">Select Category</option>
//                 <option value="Gold">Gold</option>
//                 <option value="Silver">Silver</option>
//               </select>
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Product Name</label>
//               <select
//                 className="form-select"
//                 value={newItem.product}
//                 onChange={handleProductChange}
//                 disabled={!newItem.category}
//               >
//                 <option value="">Select Product</option>
//                 {filteredProducts.map((product) => (
//                   <option key={product.id} value={product.id}>
//                     {product.item_name}
//                   </option>
//                 ))}
//               </select>
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Qty</label>
//               <input
//                 type="text"
//                 inputMode="numeric"
//                 className="form-control"
//                 placeholder="Qty"
//                 name="quantity"
//                 value={newItem.quantity}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//                 min="1"
//               />
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Weight (g)</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Weight (g)"
//                 name="weight"
//                 value={newItem.weight}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d{0,3}$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//                 step="0.001"
//                 min="0"
//               />
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">Rate</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="Rate"
//                 name="rate"
//                 value={newItem.rate}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">MC</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="MC"
//                 name="making_charge"
//                 value={newItem.making_charge}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-1">
//               <label className="form-label">MW</label>
//               <input
//                 type="text"
//                 inputMode="decimal"
//                 className="form-control"
//                 placeholder="MW"
//                 name="making_wastage"
//                 value={newItem.making_wastage}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (/^\d*\.?\d*$/.test(value)) {
//                     handleItemInputChange(e);
//                   }
//                 }}
//               />
//             </div>

//             <div className="col-md-2">
//               <label className="form-label">Amount</label>
//               <input
//                 type="text"
//                 className="form-control"
//                 placeholder="Amount"
//                 value={calculateAmount(newItem)}
//                 readOnly
//                 disabled
//               />
//             </div>

//             <div className="col-md-1">
//               {editingItemId === null ? (
//                 <button
//                   className="btn btn-success btn-sm w-100 mt-4"
//                   onClick={handleAddItem}
//                 >
//                   <i className="bi bi-plus"></i>
//                 </button>
//               ) : (
//                 <button
//                   className="btn btn-info btn-sm w-100"
//                   onClick={handleUpdateItem}
//                 >
//                   <i className="bi bi-check"></i>
//                 </button>
//               )}
//             </div>
//           </div>
//         </div>

//         <div className="container-fluid mt-2">
//           <div className="row">
//             <div className="col-lg-8">
//               <div className="row">
//                 <div className="card card-body">
//                   <h6>Item List</h6>
//                   <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
//                     <div className="table-container">
//                       <table className="table table-layout-fixed w-100">
//                         <thead className="bg-light">
//                           <tr>
//                             <th>S.No</th>
//                             <th>Category</th>
//                             <th>Product</th>
//                             <th>Qty</th>
//                             <th>Weight</th>
//                             <th>Rate</th>
//                             {/* <th>MC</th>
//                             <th>MW</th> */}
//                             <th>Amount</th>
//                             <th>Action</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {updateData.order_items.map((item, index) => (
//                             <tr key={item.id}>
//                               <td>{index + 1}</td>
//                               <td>{item.category}</td>
//                               <td>{item.product}</td>
//                               <td>{item.quantity}</td>
//                               <td>{item.weight}</td>
//                               <td>{item.rate}</td>
//                               {/* <td>{item.making_charge}</td>
//                               <td>{item.making_wastage}</td> */}
//                               <td>₹{item.amount}</td>
//                               <td>
//                                 <button
//                                   className="btn btn-sm btn-warning me-1"
//                                   onClick={() => handleEditItem(item)}
//                                 >
//                                   <i className="bi bi-pencil"></i>
//                                 </button>
//                                 <button
//                                   className="btn btn-sm btn-danger"
//                                   onClick={() => handleRemoveItem(item.id)}
//                                 >
//                                   <i className="bi bi-trash"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           ))}
//                           {updateData.order_items.length === 0 && (
//                             <tr>
//                               <td colSpan="8" className="text-center">
//                                 No items added
//                               </td>
//                             </tr>
//                           )}
//                         </tbody>
//                       </table>

//                       <div className="row">
//                         <div className="col-lg-8"></div>
//                         <div className="col-lg-4">
//                           <div className="d-flex">
//                             <h6 className="mt-2">Total: </h6>
//                             <input
//                               className="form-control mx-2"
//                               placeholder="₹"
//                               readOnly
//                               value={updateData.total || "0.00"}
//                             />
//                           </div>
//                         </div>
//                       </div>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             <div className="col-lg-4 mb-5">
//               <div className="card p-3">
//                 <div className="row">
//                   <div className="col-md-2">
//                     <label className="form-label">Advance</label>
//                   </div>
//                   <div className="col-md-5">
//                     <select
//                       className="form-select"
//                       value={updateData.advance_paytype}
//                       onChange={handleAdvancePaytypeChange}
//                     >
//                       <option value="">Select Paytype</option>
//                       <option value="Cash">Cash</option>
//                       <option value="Gpay">Gpay</option>
//                       <option value="Phonepe">Phonepe</option>
//                       <option value="Paytm">Paytm</option>
//                       <option value="Credit">Credit</option>
//                       <option value="Debit">Debit</option>
//                     </select>
//                   </div>
//                   <div className="col-md-5">
//                     <input
//                       type="tel"
//                       className="form-control"
//                       name="advance_amount"
//                       value={updateData.advance_amount}
//                       onChange={(e) =>
//                         handleAdvanceChange({
//                           target: {
//                             name: e.target.name,
//                             value: e.target.value.replace(/\D/g, ""),
//                           },
//                         })
//                       }
//                       min="0"
//                     />
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Total</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.total || ""}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row mb-2 d-flex justify-content-center">
//                   <button
//                     className="btn btn-success btn-sm w-50"
//                     onClick={openPayment}
//                   >
//                     Update Payment +
//                   </button>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Paid</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       name="paid"
//                       value={updateData.paid || ""}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-md-6">
//                     <label className="form-label">Balance</label>
//                   </div>
//                   <div className="col-md-6">
//                     <input
//                       type="text"
//                       className="form-control"
//                       value={updateData.balance || ""}
//                       readOnly
//                     />
//                   </div>
//                 </div>

//                 <div className="row">
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-secondary w-100"
//                       onClick={() => navigate("/orders")}
//                     >
//                       Cancel
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-primary w-100"
//                       onClick={handlePrint}
//                       disabled={loading}
//                     >
//                       Print
//                     </button>
//                   </div>
//                   <div className="col-lg-4">
//                     <button
//                       className="btn btn-sm btn-success w-100"
//                       onClick={handleSubmit}
//                       disabled={loading}
//                     >
//                       Update
//                     </button>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className={`modal fade ${paymentModal ? "show" : ""}`}
//         style={{ display: paymentModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="addCustomerModalLabel"
//         aria-hidden={!paymentModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6
//                 className="modal-title text-primary"
//                 id="addCustomerModalLabel"
//               >
//                 Update Payment
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={closePayment}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="row">
//                 <div className="col-lg-4">
//                   <p>
//                     Advance:{" "}
//                     <span className="text-primary">
//                       {parseFloat(updateData.advance_amount || 0).toFixed(2)}
//                     </span>
//                   </p>
//                 </div>
//                 <div className="col-lg-4">
//                   <p>
//                     Balance:{" "}
//                     <span className="text-success">
//                       {parseFloat(updateData.balance || 0).toFixed(2)}
//                     </span>
//                   </p>
//                 </div>
//                 <div className="col-lg-4">
//                   <p>
//                     Paid:{" "}
//                     <span className="text-primary">
//                       {parseFloat(updateData.paid || 0).toFixed(2)}
//                     </span>
//                   </p>
//                 </div>
//               </div>

//               <div className="row">
//                 <div className="col-lg-6">
//                   <select
//                     className="form-select"
//                     value={paymentType}
//                     onChange={(e) => setPaymentType(e.target.value)}
//                   >
//                     <option value="">Select Paytype</option>
//                     <option value="Cash">Cash</option>
//                     <option value="Gpay">Gpay</option>
//                     <option value="Phonepe">Phonepe</option>
//                     <option value="Paytm">Paytm</option>
//                     <option value="Credit">Credit</option>
//                     <option value="Debit">Debit</option>
//                   </select>
//                 </div>
//                 <div className="col-lg-4">
//                   <input
//                     type="tel"
//                     className="form-control"
//                     value={paymentAmount}
//                     onChange={(e) => setPaymentAmount(e.target.value)}
//                     placeholder="Enter Amount"
//                     min="0"
//                     step="0.01"
//                   />
//                 </div>
//                 <div className="col-lg-2">
//                   <button
//                     className="btn btn-primary btn-sm"
//                     onClick={handleAddPayment}
//                   >
//                     Add +
//                   </button>
//                 </div>
//               </div>

//               <div
//                 className="card mt-3"
//                 style={{
//                   borderRadius: "5px",
//                   backgroundColor: "#E8F0FA",
//                 }}
//               >
//                 <div className="card-body">
//                   <div className="table-responsive">
//                     <table className="table table-border">
//                       <thead>
//                         <tr>
//                           <th>S.No</th>
//                           <th>Pay Type</th>
//                           <th>Paid Amount</th>
//                           <th>Action</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {payments.length > 0 ? (
//                           payments.map((payment, index) => (
//                             <tr key={index}>
//                               <td>{index + 1}</td>
//                               <td>{payment.payment_type}</td>
//                               <td>₹{parseFloat(payment.amount).toFixed(2)}</td>
//                               <td>
//                                 <button
//                                   className="btn btn-light btn-sm me-2"
//                                   onClick={() => handleEditPayment(index)}
//                                 >
//                                   <i className="fa fa-edit text-info"></i>
//                                 </button>
//                                 <button
//                                   className="btn btn-light btn-sm me-2"
//                                   onClick={() => handleDeletePayment(index)}
//                                 >
//                                   <i className="fa fa-trash text-danger"></i>
//                                 </button>
//                               </td>
//                             </tr>
//                           ))
//                         ) : (
//                           <tr>
//                             <td colSpan="4" className="text-center">
//                               No payments added
//                             </td>
//                           </tr>
//                         )}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               </div>

//               <div className="text-end mt-2">
//                 <button
//                   className="btn btn-success btn-sm"
//                   onClick={closePayment}
//                 >
//                   Update
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div
//         className={`modal fade ${showModal ? "show" : ""}`}
//         style={{ display: showModal ? "block" : "none" }}
//         tabIndex="-1"
//         aria-labelledby="printModalLabel"
//         aria-hidden={!showModal}
//       >
//         <div className="modal-dialog modal-dialog-centered">
//           <div className="modal-content">
//             <div className="modal-header">
//               <h6 className="modal-title text-primary" id="printModalLabel">
//                 Print Confirmation
//               </h6>
//               <button
//                 type="button"
//                 className="btn-close"
//                 style={{ fontSize: "10px" }}
//                 onClick={handleCancelPrint}
//                 aria-label="Close"
//               ></button>
//             </div>
//             <div className="modal-body">
//               <div className="text-center">
//                 <p>Do you want to print the order bill?</p>
//               </div>
//               <div className="d-flex justify-content-center mt-4">
//                 <button
//                   type="button"
//                   className="btn btn-secondary btn-sm mx-2"
//                   onClick={handleCancelPrint}
//                   disabled={loading}
//                 >
//                   Cancel
//                 </button>
//                 <button
//                   type="button"
//                   className="btn btn-primary btn-sm"
//                   onClick={handleConfirmPrint}
//                   disabled={loading}
//                 >
//                   {loading ? "Processing..." : "Yes"}
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {(paymentModal || showModal) && (
//         <div className="modal-backdrop fade show"></div>
//       )}
//     </>
//   );
// }

// export default UpdateOrder;




import axios from "axios";
import { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ApiUrl from "../Environment/ApiUrl";
import { useToast } from "../Toast/ToastContext";

function UpdateOrder({ toggleSidebar }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();

  const [loading, setLoading] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [staffData, setStaffData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [editingItemId, setEditingItemId] = useState(null);
  const [paymentModal, setPaymentModal] = useState(false);
  const [paymentType, setPaymentType] = useState("");
  const [paymentAmount, setPaymentAmount] = useState("");
  const [payments, setPayments] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [showStaffModal, setShowStaffModal] = useState(false);
  const [shopList, setShopList] = useState([]); // past "By Shop" shop names, for the autofill dropdown

  const [newCustomer, setNewCustomer] = useState({ name: "", mobile: "", address: "" });
  const [newStaff, setNewStaff] = useState({
    user_id: "",
    name: "",
    mobile_number: "",
    password: "",
    role: "Employee",
    manager_id: "",
  });

  const [updateData, setUpdateData] = useState({
    order_by: "",
    order_no: "",
    order_date: "",
    delivery_date: "",
    delivery_status: "",
    customer_id: "",
    customer_name: "",
    mobile: "",
    order_items: [],
    advance_amount: "0",
    advance_paytype: "",
    balance: "0",
    paid: "0",
    total: "0",
    created_by: "",
    created_date: "",
    payment_history: [],
  });

  const [newItem, setNewItem] = useState({
    product: "",
    category: "",
    quantity: "1",
    weight: "",
    rate: "",
    making_charge: "",
    making_wastage: "",
    amount: "",
  });

  // Only Customer orders use a picker list; Shop orders use a free-text name.
  const displayList = updateData.order_by === "By Customer" ? customerData : [];

  useEffect(() => {
    if (toggleSidebar) toggleSidebar();
    fetchCustomerData();
    fetchStaffData();
    fetchProductData();
    fetchShopList();
    if (id) fetchOrderData();
  }, [id]);

  // Pull the distinct shop names (with mobile numbers) used on past "By Shop"
  // orders, so this order can pick one from a dropdown instead of retyping it.
  const fetchShopList = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/Api/orders.php`);
      const allOrders = Array.isArray(res.data.data) ? res.data.data : [];
      const seen = new Map();
      allOrders.forEach((o) => {
        const name = (o.shop_name || "").trim();
        if (!o.order_by || o.order_by !== "By Shop" || !name) return;
        if (!seen.has(name.toLowerCase())) {
          seen.set(name.toLowerCase(), { name, mobile: (o.shop_mobile || "").trim() });
        }
      });
      setShopList(Array.from(seen.values()));
    } catch (err) {
      console.error("Failed to fetch shop list", err);
    }
  };

  const fetchOrderData = async () => {
    try {
      const response = await axios.get(`${ApiUrl}/Api/orders.php/${id}`);
      const orderData = response.data?.data?.[0] || response.data?.[0];

      if (!orderData) throw new Error("No data");

      const orderItemsWithIds = (orderData.order_items || []).map((item, index) => ({
        ...item,
        id: item.id || Date.now() + index,
        product: item.product || item.product_name || "",
        making_wastage: item.making_wastage || "",
      }));

const rawHistory = orderData.payment_history || [];
const paymentHistory = [...rawHistory];
const advanceAmt = parseFloat(orderData.advance_amount || 0).toFixed(2);
const advanceIdx = paymentHistory.findIndex(
  p =>
    p.payment_type === orderData.advance_paytype &&
    parseFloat(p.amount || 0).toFixed(2) === advanceAmt
);
if (advanceIdx !== -1) {
  paymentHistory.splice(advanceIdx, 1); // remove only the one matching advance row
}

      const totalPaid = parseFloat(orderData.advance_amount || 0) +
        paymentHistory.reduce((s, p) => s + parseFloat(p.amount || 0), 0);

      const orderTotal = orderItemsWithIds.reduce((s, i) => s + parseFloat(i.amount || 0), 0).toFixed(2);

      setUpdateData({
        order_by: orderData.order_by || "",
        order_no: orderData.order_no || "",
        order_date: orderData.order_date || "",
        delivery_date: orderData.delivery_date || "",
        delivery_status: orderData.delivery_status || "",
        customer_id: orderData.customer_id || "",
        customer_name: orderData.customer_info?.name || orderData.customer_name || "",
        mobile: orderData.customer_info?.mobile || orderData.mobile || "",
        order_items: orderItemsWithIds,
        advance_amount: orderData.advance_amount || "0",
        advance_paytype: orderData.advance_paytype || "",
        balance: (parseFloat(orderTotal) - totalPaid).toFixed(2),
        paid: totalPaid.toFixed(2),
        total: orderTotal,
        created_by: orderData.created_by || "",
        created_date: orderData.created_date || "",
        payment_history: paymentHistory,
      });

      setPayments(paymentHistory);
    } catch (error) {
      toast.error("Failed to load order", 3000, "topRight");
    }
  };

  const fetchCustomerData = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/Api/customer.php`);
      setCustomerData(res.data?.data || []);
    } catch { setCustomerData([]); }
  };

  const fetchStaffData = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/Api/user.php`);
      setStaffData(res.data?.data || []);
    } catch { setStaffData([]); }
  };

  const fetchProductData = async () => {
    try {
      const res = await axios.get(`${ApiUrl}/Api/product.php`);
      setProductData(res.data?.data || []);
    } catch { setProductData([]); }
  };

  const handleOrderByChange = (e) => {
    const val = e.target.value;
    setUpdateData(prev => ({
      ...prev,
      order_by: val,
      customer_id: "",
      customer_name: "",
      mobile: "",
    }));
  };

  const handlePersonChange = (e) => {
    const id = e.target.value;
    if (!id) {
      setUpdateData(prev => ({ ...prev, customer_id: "", customer_name: "", mobile: "" }));
      return;
    }

    const person = customerData.find(c => c.customer_id === id);

    if (person) {
      setUpdateData(prev => ({
        ...prev,
        customer_id: id,
        customer_name: person.name,
        mobile: person.mobile || person.mobile_number || "",
      }));
    }
  };

  // "By Shop" orders are placed by another shop — typed/picked from a
  // datalist of past shop orders; matching an existing shop autofills mobile.
  const handleShopNameChange = (e) => {
    const value = e.target.value;
    const trimmed = value.trim();
    const match = shopList.find(s => s.name.toLowerCase() === trimmed.toLowerCase());
    setUpdateData(prev => ({
      ...prev,
      customer_name: value,
      customer_id: trimmed,
      mobile: match ? match.mobile : (trimmed === "" ? "" : prev.mobile),
    }));
  };

  const handleShopMobileChange = (e) => {
    const value = e.target.value;
    setUpdateData(prev => ({ ...prev, mobile: value }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUpdateData(prev => ({ ...prev, [name]: value }));
  };

  const handleItemInputChange = (e) => {
    const { name, value } = e.target;
    setNewItem(prev => ({ ...prev, [name]: value }));
  };

  const handleProductChange = (e) => {
    const pid = e.target.value;
    const prod = productData.find(p => p.id === pid);
    if (prod) {
      setNewItem(prev => ({
        ...prev,
        product: prod.item_name,
        category: prod.category,
      }));
    } else {
      setNewItem(prev => ({ ...prev, product: "", category: "" }));
    }
  };

  const calculateAmount = (item) => {
    if (item.quantity && item.weight && item.rate) {
      const base = parseFloat(item.quantity) * parseFloat(item.weight) * parseFloat(item.rate);
      const isCoin = item.category === "Gold Coin" || item.category === "Silver Coin";
      const mc = isCoin ? 0 : parseFloat(item.making_charge) || 0;
      const mw = isCoin ? 0 : parseFloat(item.making_wastage) || 0;
      return (base + mc + mw).toFixed(2);
    }
    return "";
  };

  // Item handlers
  const handleAddItem = () => {
    if (!newItem.category || !newItem.product || !newItem.quantity || !newItem.weight || !newItem.rate) {
      toast.error("Fill all item fields", 3000, "topRight");
      return;
    }

    const amount = calculateAmount(newItem);
    const itemToAdd = { ...newItem, id: Date.now(), amount };

    const updatedItems = [...updateData.order_items, itemToAdd];
    const total = updatedItems.reduce((s, i) => s + parseFloat(i.amount || 0), 0).toFixed(2);

    const totalPaid = parseFloat(updateData.advance_amount || 0) +
      payments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);

    setUpdateData(prev => ({
      ...prev,
      order_items: updatedItems,
      total,
      balance: (parseFloat(total) - totalPaid).toFixed(2),
    }));

    setNewItem({ product: "", category: "", quantity: "1", weight: "", rate: "", making_charge: "", making_wastage: "", amount: "" });
  };

  const handleEditItem = (item) => {
    setEditingItemId(item.id);
    setNewItem(item);
  };

  const handleUpdateItem = () => {
    if (!editingItemId) return;

    const updatedItems = updateData.order_items.map(i =>
      i.id === editingItemId ? { ...i, ...newItem, amount: calculateAmount(newItem) } : i
    );

    const total = updatedItems.reduce((s, i) => s + parseFloat(i.amount || 0), 0).toFixed(2);
    const totalPaid = parseFloat(updateData.advance_amount || 0) +
      payments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);

    setUpdateData(prev => ({
      ...prev,
      order_items: updatedItems,
      total,
      balance: (parseFloat(total) - totalPaid).toFixed(2),
    }));

    setEditingItemId(null);
    setNewItem({ product: "", category: "", quantity: "1", weight: "", rate: "", making_charge: "", making_wastage: "", amount: "" });
  };

  const handleRemoveItem = (id) => {
    const filtered = updateData.order_items.filter(i => i.id !== id);
    const total = filtered.reduce((s, i) => s + parseFloat(i.amount || 0), 0).toFixed(2);
    const totalPaid = parseFloat(updateData.advance_amount || 0) +
      payments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);

    setUpdateData(prev => ({
      ...prev,
      order_items: filtered,
      total,
      balance: (parseFloat(total) - totalPaid).toFixed(2),
    }));
  };

  // Payment & Advance
  const handleAdvanceChange = (e) => {
    const val = e.target.value.replace(/\D/g, "") || "0";
    const totalPaid = parseFloat(val) + payments.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
    setUpdateData(prev => ({
      ...prev,
      advance_amount: val,
      paid: totalPaid.toFixed(2),
      balance: (parseFloat(prev.total || 0) - totalPaid).toFixed(2),
    }));
  };

  const handleAdvancePaytypeChange = (e) => {
    setUpdateData(prev => ({ ...prev, advance_paytype: e.target.value }));
  };

  const openPayment = () => setPaymentModal(true);
  const closePayment = () => {
    setPaymentType("");
    setPaymentAmount("");
    setPaymentModal(false);
  };

const addingPaymentRef = useRef(false);

const handleAddPayment = () => {
  if (addingPaymentRef.current) return;
  addingPaymentRef.current = true;

  if (!paymentType || !paymentAmount || parseFloat(paymentAmount) <= 0) {
    toast.error("Select type & valid amount", 3000, "topRight");
    addingPaymentRef.current = false;
    return;
  }

  const newPay = {
    order_no: updateData.order_no,
    date: new Date().toISOString().split("T")[0],
    payment_type: paymentType,
    amount: parseFloat(paymentAmount).toFixed(2),
  };

  const updated = [...payments, newPay];
  const totalPaid = parseFloat(updateData.advance_amount || 0) +
    updated.reduce((s, p) => s + parseFloat(p.amount || 0), 0);

  setPayments(updated);
  setUpdateData(prev => ({
    ...prev,
    paid: totalPaid.toFixed(2),
    balance: (parseFloat(prev.total || 0) - totalPaid).toFixed(2),
  }));
  setPaymentType("");
  setPaymentAmount("");

  addingPaymentRef.current = false;
};

  const handleDeletePayment = (index) => {
    const updated = payments.filter((_, i) => i !== index);
    const totalPaid = parseFloat(updateData.advance_amount || 0) +
      updated.reduce((s, p) => s + parseFloat(p.amount || 0), 0);
    setPayments(updated);
    setUpdateData(prev => ({
      ...prev,
      paid: totalPaid.toFixed(2),
      balance: (parseFloat(prev.total || 0) - totalPaid).toFixed(2),
    }));
  };

  // Save & Print
  const preparePayload = () => {
    const items = updateData.order_items.map(({ id, ...i }) => i);
    const paymentHistory = [...payments];
    if (updateData.advance_amount > 0 && updateData.advance_paytype) {
      paymentHistory.unshift({
        order_no: updateData.order_no,
        date: updateData.order_date,
        payment_type: updateData.advance_paytype,
        amount: parseFloat(updateData.advance_amount).toFixed(2),
      });
    }
    const isShop = updateData.order_by === "By Shop";
    return {
      ...updateData,
      order_items: items,
      payment_history: paymentHistory,
      shop_name: isShop ? updateData.customer_name : "",
      shop_mobile: isShop ? updateData.mobile : "",
    };
  };

  const saveOrder = async () => {
    const payload = preparePayload();
    const res = await axios.put(`${ApiUrl}/Api/orders.php/${id}`, payload);
    if (res.status !== 200) throw new Error("Update failed");
    return res;
  };

  const handleSubmit = async () => {
    if (!updateData.order_by || !updateData.customer_id || updateData.order_items.length === 0) {
      toast.error("Fill required fields", 3000, "topRight");
      return;
    }
    setLoading(true);
    try {
      await saveOrder();
      toast.success("Order updated!");
      navigate("/orders");
    } catch { toast.error("Update failed"); }
    finally { setLoading(false); }
  };

  const handlePrint = async () => {
    if (!updateData.order_by || !updateData.customer_id || updateData.order_items.length === 0) return;
    setLoading(true);
    try {
      await saveOrder();
      setShowModal(true);
    } catch { toast.error("Save failed"); }
    finally { setLoading(false); }
  };

  const handleConfirmPrint = () => {
    setShowModal(false);
    navigate(`/order-big-bill/${updateData.order_no}`);
  };

  const filteredProducts = productData.filter(p => p.category === newItem.category);

  return (
    <>
      <div className="container-fluid">
        <div className="row g-3">
          <div className="col-lg-3">
            <div className="card p-2 h-100">
              <div className="row g-2">
                <div className="col-md-6">
                  <label className="form-label">Order ID</label>
                  <input type="text" className="form-control" value={updateData.order_no} disabled readOnly />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Order Date</label>
                  <input type="date" className="form-control" name="order_date" value={updateData.order_date} onChange={handleInputChange} />
                </div>
              </div>
            </div>
          </div>

          {/* ORDER BY + DROPDOWN - NOW WORKS PERFECTLY */}
          <div className="col-lg-9">
            <div className="card h-100 p-2">
              <div className="row g-2">
                <div className="col-sm-6 col-md-2">
                  <label className="form-label">Order By</label>
                  <select
                    className="form-control"
                    value={updateData.order_by}
                    onChange={handleOrderByChange}
                  >
                    <option value="">Select</option>
                    <option value="By Shop">By Shop</option>
                    <option value="By Customer">By Customer</option>
                  </select>
                </div>

                <div className="col-sm-6 col-md-4">
                  <label className="form-label">
                    {updateData.order_by === "By Shop" ? "Shop Name" : "Customer Name"}
                  </label>
                  {updateData.order_by === "By Shop" ? (
                    <>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter or select the shop's name"
                        value={updateData.customer_name}
                        onChange={handleShopNameChange}
                        list="shopNamesListUpdate"
                        autoComplete="off"
                      />
                      <datalist id="shopNamesListUpdate">
                        {shopList.map((s) => (
                          <option key={s.name} value={s.name} />
                        ))}
                      </datalist>
                    </>
                  ) : (
                    <div className="input-group">
                      <select
                        className="form-select"
                        value={updateData.customer_id || ""}
                        onChange={handlePersonChange}
                        disabled={!updateData.order_by}
                      >
                        <option value="">
                          {updateData.order_by ? "Select..." : "First select Order By"}
                        </option>
                        {displayList.map(item => (
                          <option
                            key={item.customer_id}
                            value={item.customer_id}
                          >
                            {`${item.customer_id} - ${item.name}`}
                          </option>
                        ))}
                      </select>
                      <button
                        type="button"
                        className="btn btn-outline-dark btn-sm"
                        onClick={() => setShowCustomerModal(true)}
                        disabled={!updateData.order_by}
                      >
                        <i className="bi bi-plus"></i>
                      </button>
                    </div>
                  )}
                </div>

                <div className="col-sm-6 col-md-2">
                  <label className="form-label">Mobile Number</label>
                  <input
                    type="text"
                    className="form-control"
                    value={updateData.mobile}
                    onChange={updateData.order_by === "By Shop" ? handleShopMobileChange : undefined}
                    disabled={updateData.order_by !== "By Shop"}
                  />
                </div>

                <div className="col-sm-6 col-md-2">
                  <label className="form-label">Delivery Status</label>
                  <select
                    className="form-select"
                    name="delivery_status"
                    value={updateData.delivery_status}
                    onChange={handleInputChange}
                  >
                    <option value="">Select</option>
                    <option value="Inprogress">Inprogress</option>
                    <option value="Confirm">Confirm</option>
                  </select>
                </div>

                {updateData.delivery_status === "Confirm" && (
                  <div className="col-sm-6 col-md-2">
                    <label className="form-label">Delivery Date</label>
                    <input
                      type="date"
                      className="form-control"
                      name="delivery_date"
                      value={updateData.delivery_date}
                      onChange={handleInputChange}
                      min={updateData.order_date}
                    />
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* ITEM INPUT ROW */}
        <div className="card card-body mt-2">
          <div className="row">
            <div className="col-md-2">
              <label className="form-label">Select Category</label>
              <select
                className="form-select"
                value={newItem.category}
                name="category"
                onChange={(e) => {
                  handleItemInputChange(e);
                  setNewItem(prev => ({ ...prev, product: "" }));
                }}
              >
                <option value="">Select Category</option>
                <option value="Gold">Gold</option>
                <option value="Silver">Silver</option>
                <option value="Gold Coin">Gold Coin</option>
                <option value="Silver Coin">Silver Coin</option>
              </select>
            </div>

            <div className="col-md-2">
              <label className="form-label">Product Name</label>
              <select
                className="form-select"
                value={newItem.product}
                onChange={handleProductChange}
                disabled={!newItem.category}
              >
                <option value="">Select Product</option>
                {filteredProducts.map(product => (
                  <option key={product.id} value={product.id}>
                    {product.item_name_english || product.item_name}
                    {product.item_name_tamil ? ` / ${product.item_name_tamil}` : ""}
                  </option>
                ))}
              </select>
            </div>

            {/* <div className="col-md-1">
              <label className="form-label">Qty</label>
              <input
                type="text"
                className="form-control"
                name="quantity"
                value={newItem.quantity}
                onChange={(e) => {
                  if (/^\d*$/.test(e.target.value)) handleItemInputChange(e);
                }}
              />
            </div> */}

            <div className="col-md-1">
              <label className="form-label">Weight (g)</label>
              <input
                type="text"
                className="form-control"
                name="weight"
                value={newItem.weight}
                onChange={(e) => {
                  if (/^\d*\.?\d{0,3}$/.test(e.target.value)) handleItemInputChange(e);
                }}
              />
            </div>

            <div className="col-md-1">
              <label className="form-label">Rate</label>
              <input
                type="text"
                className="form-control"
                name="rate"
                value={newItem.rate}
                onChange={(e) => {
                  if (/^\d*\.?\d*$/.test(e.target.value)) handleItemInputChange(e);
                }}
              />
            </div>

            {newItem.category !== "Gold Coin" && newItem.category !== "Silver Coin" && (
              <>
                <div className="col-md-1">
                  <label className="form-label">MC</label>
                  <input
                    type="text"
                    className="form-control"
                    name="making_charge"
                    value={newItem.making_charge}
                    onChange={handleItemInputChange}
                  />
                </div>

                <div className="col-md-1">
                  <label className="form-label">MW</label>
                  <input
                    type="text"
                    className="form-control"
                    name="making_wastage"
                    value={newItem.making_wastage}
                    onChange={handleItemInputChange}
                  />
                </div>
              </>
            )}

            <div className="col-md-2">
              <label className="form-label">Amount</label>
              <input
                type="text"
                className="form-control"
                value={calculateAmount(newItem)}
                readOnly
                disabled
              />
            </div>

            <div className="col-md-1">
              {editingItemId === null ? (
                <button className="btn btn-success btn-sm w-100 mt-4" onClick={handleAddItem}>
                  <i className="bi bi-plus"></i>
                </button>
              ) : (
                <button className="btn btn-info btn-sm w-100" onClick={handleUpdateItem}>
                  <i className="bi bi-check"></i>
                </button>
              )}
            </div>
          </div>
        </div>

        {/* ITEM LIST + PAYMENT SECTION */}
        <div className="container-fluid mt-2">
          <div className="row">
            <div className="col-lg-8">
              <div className="card card-body">
                <h6>Item List</h6>
                <div className="p-3" style={{ backgroundColor: "#E8F0FA" }}>
                  <table className="table">
                    <thead className="bg-light">
                      <tr>
                        <th>S.No</th>
                        <th>Category</th>
                        <th>Product</th>
                        {/* <th>Qty</th> */}
                        <th>Weight</th>
                        <th>Rate</th>
                        <th>Amount</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {updateData.order_items.map((item, index) => (
                        <tr key={item.id}>
                          <td>{index + 1}</td>
                          <td>{item.category}</td>
                          <td>{item.product}</td>
                          {/* <td>{item.quantity}</td> */}
                          <td>{item.weight}</td>
                          <td>{item.rate}</td>
                          <td>₹{item.amount}</td>
                          <td>
                            <button className="btn btn-sm btn-warning me-1" onClick={() => handleEditItem(item)}>
                              <i className="bi bi-pencil"></i>
                            </button>
                            <button className="btn btn-sm btn-danger" onClick={() => handleRemoveItem(item.id)}>
                              <i className="bi bi-trash"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                      {updateData.order_items.length === 0 && (
                        <tr><td colSpan="8" className="text-center">No items</td></tr>
                      )}
                    </tbody>
                  </table>

                  <div className="d-flex justify-content-end mt-3">
                    <h6>Total: </h6>
                    <input className="form-control w-25 ms-2" value={updateData.total || "0.00"} readOnly />
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4">
              <div className="card p-3">
                <div className="row mb-3">
                  <div className="col-3"><label>Advance</label></div>
                  <div className="col-4">
                    <select className="form-select" value={updateData.advance_paytype} onChange={handleAdvancePaytypeChange}>
                      <option value="">Type</option>
                      <option>Cash</option><option>Gpay</option><option>Phonepe</option><option>Paytm</option><option>Credit</option><option>Debit</option>
                    </select>
                  </div>
                  <div className="col-5">
                    <input type="text" className="form-control" value={updateData.advance_amount} onChange={handleAdvanceChange} />
                  </div>
                </div>

                <div className="row mb-2"><div className="col-6">Total</div><div className="col-6"><input className="form-control" value={updateData.total} readOnly /></div></div>
                <div className="row mb-2 text-center"><button className="btn btn-success btn-sm w-50" onClick={openPayment}>Update Payment +</button></div>
                <div className="row mb-2"><div className="col-6">Paid</div><div className="col-6"><input className="form-control" value={updateData.paid} readOnly /></div></div>
                <div className="row"><div className="col-6">Balance</div><div className="col-6"><input className="form-control" value={updateData.balance} readOnly /></div></div>

                <div className="row mt-4">
                  <div className="col-4"><button className="btn btn-secondary btn-sm w-100" onClick={() => navigate("/orders")}>Cancel</button></div>
                  <div className="col-4"><button className="btn btn-primary btn-sm w-100" onClick={handlePrint} disabled={loading}>Print</button></div>
                  <div className="col-4"><button className="btn btn-success btn-sm w-100" onClick={handleSubmit} disabled={loading}>Update</button></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* PAYMENT MODAL */}
      {paymentModal && (
        <div className="modal fade show" style={{display: "block"}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6 className="modal-title text-primary">Update Payment</h6>
                <button type="button" className="btn-close" onClick={closePayment}></button>
              </div>
              <div className="modal-body">
                <div className="row text-center mb-3 p-2 bg-light">
                  <div className="col-4"><strong>Advance</strong><br/>₹{parseFloat(updateData.advance_amount || 0).toFixed(2)}</div>
                  <div className="col-4"><strong>Paid</strong><br/>₹{parseFloat(updateData.paid || 0).toFixed(2)}</div>
                  <div className="col-4"><strong>Balance</strong><br/>₹{parseFloat(updateData.balance || 0).toFixed(2)}</div>
                </div>

                <div className="row g-2 align-items-end">
                  <div className="col-5">
                    <select className="form-select" value={paymentType} onChange={e => setPaymentType(e.target.value)}>
                      <option value="">Type</option>
                      <option>Cash</option><option>Gpay</option><option>Phonepe</option><option>Paytm</option><option>Credit</option><option>Debit</option>
                    </select>
                  </div>
                  <div className="col-4">
                    <input type="text" className="form-control" value={paymentAmount}
                      onChange={e => setPaymentAmount(e.target.value.replace(/\D/g,""))} placeholder="Amount" />
                  </div>
                  <div className="col-3">
                    <button className="btn btn-success btn-sm w-100" onClick={handleAddPayment}>Add</button>
                  </div>
                </div>

                <div className="table-responsive mt-3">
                  <table className="table table-sm">
                    <thead><tr><th>#</th><th>Type</th><th>Amount</th><th></th></tr></thead>
                    <tbody>
                      {payments.map((p, i) => (
                        <tr key={i}>
                          <td>{i+1}</td>
                          <td>{p.payment_type}</td>
                          <td>₹{p.amount}</td>
                          <td><button className="btn btn-danger btn-sm" onClick={() => handleDeletePayment(i)}>X</button></td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                <div className="text-end mt-3">
                  <button className="btn btn-primary" onClick={closePayment}>Done</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* PRINT CONFIRM MODAL */}
      {showModal && (
        <div className="modal fade show" style={{display: "block"}}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6>Print Confirmation</h6>
                <button className="btn-close" onClick={() => setShowModal(false)}></button>
              </div>
              <div className="modal-body text-center">
                <p>Do you want to print the order bill?</p>
                <button className="btn btn-secondary btn-sm mx-2" onClick={() => { setShowModal(false); navigate("/orders"); }}>Cancel</button>
                <button className="btn btn-primary btn-sm mx-2" onClick={handleConfirmPrint}>Yes</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* QUICK ADD CUSTOMER MODAL */}
      {showCustomerModal && (
        <div className="modal fade show" style={{display: "block"}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6>Add New Customer</h6>
                <button type="button" className="btn-close" onClick={() => setShowCustomerModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label>Name *</label>
                  <input type="text" className="form-control" value={newCustomer.name}
                    onChange={e => setNewCustomer(p => ({...p, name: e.target.value}))} />
                </div>
                <div className="mb-3">
                  <label>Mobile *</label>
                  <input type="text" className="form-control" value={newCustomer.mobile}
                    onChange={e => setNewCustomer(p => ({...p, mobile: e.target.value.replace(/\D/g,"").slice(0,10)}))} />
                </div>
                <div className="mb-3">
                  <label>Address</label>
                  <input type="text" className="form-control" value={newCustomer.address}
                    onChange={e => setNewCustomer(p => ({...p, address: e.target.value}))} />
                </div>
                <div className="text-end">
                  <button className="btn btn-primary"
                    onClick={async () => {
                      if (!newCustomer.name || !newCustomer.mobile) return toast.error("Required");
                      try {
                        const res = await axios.post(`${ApiUrl}/Api/customer.php`, {
                          name: newCustomer.name,
                          mobile: newCustomer.mobile,
                          address: newCustomer.address || "",
                          customer_type: "Regular",
                          status: "Active",
                        });
                        toast.success("Customer added!");
                        await fetchCustomerData();
                        setUpdateData(p => ({...p, customer_id: res.data.customer_id, customer_name: newCustomer.name, mobile: newCustomer.mobile}));
                        setNewCustomer({name:"",mobile:"",address:""});
                        setShowCustomerModal(false);
                      } catch { toast.error("Failed"); }
                    }}>
                    Add Customer
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* QUICK ADD STAFF MODAL */}
      {showStaffModal && (
        <div className="modal fade show" style={{display: "block"}} tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h6>Add New Staff</h6>
                <button type="button" className="btn-close" onClick={() => setShowStaffModal(false)}></button>
              </div>
              <div className="modal-body">
                <div className="row mb-3">
                  <div className="col-6">
                    <label>Staff ID *</label>
                    <input type="text" className="form-control" value={newStaff.user_id}
                      onChange={e => setNewStaff(p => ({...p, user_id: e.target.value.toUpperCase()}))} />
                  </div>
                  <div className="col-6">
                    <label>Role</label>
                    <select className="form-select" value={newStaff.role}
                      onChange={e => setNewStaff(p => ({...p, role: e.target.value}))}>
                      <option>Employee</option>
                      <option>Manager</option>
                    </select>
                  </div>
                </div>
                <div className="mb-3">
                  <label>Name *</label>
                  <input type="text" className="form-control" value={newStaff.name}
                    onChange={e => setNewStaff(p => ({...p, name: e.target.value}))} />
                </div>
                <div className="mb-3">
                  <label>Mobile *</label>
                  <input type="text" className="form-control" value={newStaff.mobile_number}
                    onChange={e => setNewStaff(p => ({...p, mobile_number: e.target.value.replace(/\D/g,"").slice(0,10)}))} />
                </div>
                <div className="mb-3">

                  
                  <label>Password *</label>
                  <input type="password" className="form-control" value={newStaff.password}
                    onChange={e => setNewStaff(p => ({...p, password: e.target.value}))} />
                </div>
                {newStaff.role === "Employee" && (
                  <div className="mb-3">
                    <label>Manager</label>
                    <select className="form-select" value={newStaff.manager_id}
                      onChange={e => setNewStaff(p => ({...p, manager_id: e.target.value}))}>
                      <option value="">Select Manager</option>
                      {staffData.filter(s => s.role === "Manager").map(m => (
                        <option key={m.user_id} value={m.user_id}>{m.user_id} - {m.name}</option>
                      ))}
                    </select>
                  </div>
                )}
                <div className="text-end">
                  <button className="btn btn-primary"
                    onClick={async () => {
                      if (!newStaff.user_id || !newStaff.name || !newStaff.mobile_number || !newStaff.password) {
                        toast.error("Fill all fields");
                        return;
                      }
                      try {
                        await axios.post(`${ApiUrl}/Api/user.php`, {
                          user_id: newStaff.user_id.toUpperCase(),
                          name: newStaff.name,
                          mobile_number: newStaff.mobile_number,
                          password: newStaff.password,
                          role: newStaff.role,
                          login_status: "Active",
                          manager_id: newStaff.role === "Employee" ? newStaff.manager_id : "",
                        });
                        toast.success("Staff added!");
                        await fetchStaffData();
                        setUpdateData(p => ({
                          ...p,
                          customer_id: newStaff.user_id.toUpperCase(),
                          customer_name: newStaff.name,
                          mobile: newStaff.mobile_number,
                        }));
                        setNewStaff({user_id:"",name:"",mobile_number:"",password:"",role:"Employee",manager_id:""});
                        setShowStaffModal(false);
                      } catch { toast.error("Failed"); }
                    }}>
                    Add Staff
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* BACKDROP */}
      {(paymentModal || showModal || showCustomerModal || showStaffModal) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
}

export default UpdateOrder;